export const getUniqueListByKey = <E, K extends keyof E>(list: E[], key: K): E[] => {
  return [
    ...list
      .reduce((map, obj) => {
        return map.set(obj[key], obj);
      }, new Map())
      .values(),
  ];
};
